import { makeStyles } from '@material-ui/core';

import { orange } from 'shared/styles/colors';

export default makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '0.5rem',
    backgroundColor: orange.D6,
    borderRadius: '0.25rem',
    padding: '0.5rem 0.75rem',
    marginBottom: '0.5rem',
  },
  icon: {
    fontSize: '1.25rem',
    width: '1.25rem',
    height: '1.25rem',
    color: orange[70],
    flexShrink: 0,
    marginTop: '0.125rem',
  },
  text: {
    margin: 0,
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    color: orange[70],
  },
});
